$_vikon(() => {
    const key = $_vikon('[name=ajax_blank_num_identity]').val();
    const dataRemoteUri = $_vikon('[name=ajax_blank_num_remote_uri]').val();
    const competitionGroupId = $_vikon('[name=ajax_blank_num_campaign_level_id]').val();
    $_vikon.ajax({
        type: 'get',
        url: dataRemoteUri + competitionGroupId,
        dataType: 'json',
        data: {},
        headers: {
            Authorization: `Bearer ${key}`,
            Accept: 'application/json; charset=utf-8',
        },
        success: (response) => {
            $_vikon('#blank_num_ajax_wrapper').html(response.payload.table);
        },
        error: (err) => {
            $_vikon('#blank_num_ajax_wrapper').html('Не удалось получить информацию о количестве поданных заявлений.');
        },
    });
});
